import { Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxFloatUiPlacements, NgxFloatUiTriggers, NgxFloatUiDirective, NgxFloatUiContentComponent } from 'ngx-float-ui';
import { IconButtonComponent } from '../icon-button/icon-button.component';

import { IconButtonColorEnumPipe } from '../icon-button/icon-button-color-enum.pipe';

@Component({
    selector: 'app-popper-tool-tip',
    templateUrl: './popper-tool-tip.component.html',
    styleUrls: ['./popper-tool-tip.component.scss'],
    standalone: true,
    imports: [NgxFloatUiDirective, IconButtonComponent, NgxFloatUiContentComponent, IconButtonColorEnumPipe]
})
export class PopperToolTipComponent implements OnInit {
  @ViewChild('tooltipElement', { static: true }) tooltipElement!: ElementRef;
  title: string = "";
  @Input() iconColor: string="BLUE";
  @Input() heightInPx: string = "16px";
  @Input() widthInPx: string = "16px";
  @Input() screenReaderText: string = "";
  @Input() popperPlacementParam: NgxFloatUiPlacements | Function = NgxFloatUiPlacements.AUTO;
  @Input() isHtmlContent: boolean = false;
  @Input() isChildOfMenuBar: boolean = false;
  popperPlacement: NgxFloatUiPlacements;
  popperTrigger: NgxFloatUiTriggers = this.deviceService.isDesktop() ? NgxFloatUiTriggers.hover : NgxFloatUiTriggers.click;

  constructor(private ngZone: NgZone, private deviceService: DeviceDetectorService) { }

  ngOnInit(): void {

    this.popperPlacement = this.popperPlacementParam instanceof Function ? this.popperPlacementParam() : this.popperPlacementParam;
  }

}
